import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { CurrentUser } from './currentUser.service';

@Injectable()
export class CanActivateContrib implements CanActivate {
  constructor(private router: Router,
  private currentUser: CurrentUser,
  private activatedRoute: ActivatedRoute) {}

  public canActivate(route: ActivatedRouteSnapshot): boolean {

    if (!(this.currentUser.get() ? this.currentUser.get().first_name !== '' : false)) {
      this.router.navigate(['/projects/' + route.url[0].path + '/contribute'],
      {queryParams: route.queryParams});
      return false;
    }
    return true;
  }
}
